/**
 * `navigator.language` — singular. NOT `navigator.languages[0]` plural.
 * The backend pipeline keys off the singular form (mirrors GA4's
 * `device.language`); using the plural would silently break parity on
 * browsers where the two diverge (e.g. user added a secondary locale
 * that bubbles to position 0).
 */
export function getLanguage(): string {
  if (typeof window === 'undefined') return ''
  return navigator.language ?? ''
}
